import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const EmployeeService = {
  getEmployee: () => {
    const url = REQUEST_URL.EMPLOYEE;
    return RequestUtil.get({ url });
  },

  getEmployeePresence: () => {
    const url = REQUEST_URL.EMPLOYEE_PRESENCE;
    return RequestUtil.get({ url });
  },

  getEmployeeDetailById: (id: string) => {
    const url = `${REQUEST_URL.EMPLOYEE}/${id}`;
    return RequestUtil.get({ url });
  },

  createEmployee: (data: any) => {
    const url = REQUEST_URL.EMPLOYEE;
    return RequestUtil.post({ url, data });
  },

  updateEmployee: (data: any) => {
    const url = REQUEST_URL.EMPLOYEE;
    return RequestUtil.put({ url, data });
  },

  deleteEmployee: (id: string) => {
    const url = REQUEST_URL.DELETE_EMPLOYEE.replace("_id", id);
    return RequestUtil.delete({ url });
  },

  getEmployeeTeam: () => {
    const url = REQUEST_URL.EMPLOYEE_TEAM;
    return RequestUtil.get({ url });
  },

  getEmployeeTeamById: (id: string) => {
    const url = REQUEST_URL.EMPLOYEE_TEAM_DETAIL.replace("_id", id);
    return RequestUtil.get({ url });
  },

  createEmployeeTeam: (data: { name: string }) => {
    const url = REQUEST_URL.EMPLOYEE_TEAM;
    return RequestUtil.post({ url, data });
  },

  updateEmployeeTeam: (id: string, data: { name: string; leaderId?: string | null }) => {
    const url = REQUEST_URL.EMPLOYEE_TEAM_DETAIL.replace("_id", id);
    return RequestUtil.put({ url, data });
  },

  setEmployeeTeamMembers: (id: string, employeeIds: string[]) => {
    const url = REQUEST_URL.EMPLOYEE_TEAM_MEMBERS.replace("_id", id);
    return RequestUtil.put({ url, data: { employeeIds } });
  },

  deleteEmployeeTeam: (id: string) => {
    const url = REQUEST_URL.DELETE_EMPLOYEE_TEAM.replace("_id", id);
    return RequestUtil.delete({ url });
  },

  getEmployeePosition: () => {
    const url = REQUEST_URL.EMPLOYEE_POSITION;
    return RequestUtil.get({ url });
  },

  createEmployeePosition: (data: any) => {
    const url = REQUEST_URL.EMPLOYEE_POSITION;
    return RequestUtil.post({ url, data });
  },

  deleteEmployeePosition: (id: string) => {
    const url = REQUEST_URL.DELETE_EMPLOYEE_POSITION.replace("_id", id);
    return RequestUtil.get({ url });
  },

  uploadAvatarEmployee: (data: FormData) => {
    const url = REQUEST_URL.EMPLOYEE_AVATAR;
    return RequestUtil.put({ url, data });
  },

  uploadProfilePhotoEmployee: (data: FormData) => {
    const url = REQUEST_URL.EMPLOYEE_PROFILE_PHOTO;
    return RequestUtil.put({ url, data });
  },

  importEmployee: (data: FormData) => {
    const url = REQUEST_URL.EMPLOYEE_IMPORT;
    return RequestUtil.post({ url, data });
  },

  triggerDeviceSync: () => {
    const url = REQUEST_URL.EMPLOYEE_TRIGGER_DEVICE_SYNC;
    return RequestUtil.post({ url, data: {} });
  },

  deleteAvatarEmployee: (id: string) => {
    const url = REQUEST_URL.DELETE_AVATAR_EMPLOYEE.replace("{id}", id);
    return RequestUtil.delete({ url });
  },

  deleteProfilePhotoEmployee: (id: string) => {
    const url = REQUEST_URL.DELETE_EMPLOYEE_PROFILE_PHOTO.replace("{id}", id);
    return RequestUtil.delete({ url });
  },

  addRuleViolation: (
    id: string,
    data: { type: string; date: string; note?: string }
  ) => {
    const url = `${REQUEST_URL.EMPLOYEE}/${id}/rule-violations`;
    return RequestUtil.post({ url, data });
  },

  deleteRuleViolation: (id: string, violationId: string) => {
    const url = `${REQUEST_URL.EMPLOYEE}/${id}/rule-violations/${violationId}`;
    return RequestUtil.delete({ url });
  },
};
